var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Mock incoming customer rexquest
var MOCK_REQUEST = {
    id: 'REQ-1042',
    customerName: 'Jean Dupont',
    customerEmail: 'jean.dupont@email.com',
    customerPhone: '+33 6 98 76 54 32',
    address: '123 Rue de Rivoli, 75001 Paris',
    moveDate: '2024-08-15',
    isFlexible: true,
    flexibleDuration: '1_week',
    notes: '3rd floor, no elevator. Heavy antique desk requires special care.',
    photos: [
        'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
    ],
};
export default function AdminQuoteDetailPage() {
    var _this = this;
    var slug = useParams().slug;
    var _a = useState(null), modalImage = _a[0], setModalImage = _a[1];
    var _b = useState(false), isGenerated = _b[0], setIsGenerated = _b[1];
    var _c = useState(false), isDispatching = _c[0], setIsDispatching = _c[1];
    var _d = useState({
        slug: slug,
        file: null,
        block: { id: '', slug: '', title: '', metas: { address: '', email: '', moveDate: '', Photos: [] } },
    }), data = _d[0], setData = _d[1];
    // Admin editable quote data
    var _e = useState({
        totalM3: 25.0,
        estimatedMovePrice: 0,
        materials: [],
    }), quoteData = _e[0], setQuoteData = _e[1];
    var _f = useState(''), moverEmails = _f[0], setMoverEmails = _f[1];
    var _g = useState(false), isEstimating = _g[0], setIsEstimating = _g[1];
    var _h = useState(null), bedrockError = _h[0], setBedrockError = _h[1];
    // Calculate totals
    var materialsTotal = quoteData.materials.reduce(function (sum, item) { return sum + item.quantity * item.unitPrice; }, 0);
    var grandTotal = materialsTotal + quoteData.estimatedMovePrice;
    var requestBedrockEstimate = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, json, materialsUpdated;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetch(App.api_base + '/generate/' + slug, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Vuedoo-Domain': App.domain,
                            'X-Vuedoo-Access-Key': '',
                        },
                        body: JSON.stringify({}),
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error('Bedrock estimate request failed');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _c.sent();
                    console.log(json);
                    materialsUpdated = json.quoteJson.materials.map(function (item, index) {
                        var name = Object.keys(item)[0];
                        var quantity = item[name];
                        return {
                            id: index + 1, // 1-based ID
                            name: name,
                            quantity: quantity,
                            unitPrice: 0, // Default to 0, can be edited by admin
                        };
                    });
                    return [2 /*return*/, {
                            totalM3: Number((_a = json.quoteJson.totalM3) !== null && _a !== void 0 ? _a : 0),
                            estimatedMovePrice: Number((_b = json.quoteJson.estimatedMovePrice) !== null && _b !== void 0 ? _b : 0),
                            materials: materialsUpdated,
                        }];
            }
        });
    }); };
    var handleGenerateList = function () { return __awaiter(_this, void 0, void 0, function () {
        var fallbackEstimate, estimate, normalizedMaterials, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsEstimating(true);
                    setBedrockError(null);
                    fallbackEstimate = {
                        totalM3: 28.5,
                        estimatedMovePrice: 450,
                        materials: [
                            { id: '1', name: 'Standard Carton', quantity: 20, unitPrice: 2.50 },
                            { id: '2', name: 'Book Carton (Renforcé)', quantity: 8, unitPrice: 3.00 },
                            { id: '3', name: 'Penderie (Wardrobe)', quantity: 3, unitPrice: 4.50 },
                            { id: '4', name: 'Bubble Wrap Roll', quantity: 2, unitPrice: 15.00 },
                            { id: '5', name: 'Packing Paper', quantity: 5, unitPrice: 2.00 },
                            { id: '6', name: 'Packing Tape', quantity: 2, unitPrice: 3.50 },
                        ],
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestBedrockEstimate()];
                case 2:
                    estimate = _a.sent();
                    normalizedMaterials = estimate.materials.length
                        ? estimate.materials
                        : fallbackEstimate.materials;
                    console.log('Bedrock estimate received:', estimate);
                    setQuoteData({
                        totalM3: estimate.totalM3 || fallbackEstimate.totalM3,
                        estimatedMovePrice: estimate.estimatedMovePrice || fallbackEstimate.estimatedMovePrice,
                        materials: normalizedMaterials,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    setBedrockError('Unable to fetch a Bedrock estimate. Using default admin estimate.');
                    setQuoteData(fallbackEstimate);
                    return [3 /*break*/, 5];
                case 4:
                    setIsEstimating(false);
                    setIsGenerated(true);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleNumberChange = function (field, value) {
        var numValue = value === '' ? 0 : parseFloat(value);
        setQuoteData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = numValue, _a)));
        });
    };
    var updateMaterial = function (id, field, value) {
        setQuoteData(function (prev) { return (__assign(__assign({}, prev), { materials: prev.materials.map(function (item) {
                var _a;
                return item.id === id ? __assign(__assign({}, item), (_a = {}, _a[field] = value, _a)) : item;
            }) })); });
    };
    useEffect(function () {
        prepareUpload(data.slug);
    }, []);
    var prepareUpload = function (slug) { return __awaiter(_this, void 0, void 0, function () {
        var response, res, photos, quoteJson, materialsUpdated;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetch(App.api_base + '/devis/' + data.slug, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Vuedoo-Domain': App.domain,
                            'X-Vuedoo-Access-Key': ''
                        },
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    res = _c.sent();
                    if (res.status === 'success') {
                        if (res.devis.metas && res.devis.metas.Photos) {
                            photos = JSON.parse(res.devis.metas.Photos);
                            res.devis.metas.Photos = photos;
                            if (res.devis.metas.Quote != undefined) {
                                quoteJson = res.devis.metas.Quote = JSON.parse(res.devis.metas.Quote);
                                materialsUpdated = quoteJson.materials.map(function (item, index) {
                                    var name = Object.keys(item)[0];
                                    var quantity = item[name];
                                    return {
                                        id: index + 1, // 1-based ID
                                        name: name,
                                        quantity: quantity,
                                        unitPrice: 0, // Default to 0, can be edited by admin
                                    };
                                });
                                setQuoteData({
                                    totalM3: Number((_a = quoteJson.totalM3) !== null && _a !== void 0 ? _a : 0),
                                    estimatedMovePrice: Number((_b = quoteJson.estimatedMovePrice) !== null && _b !== void 0 ? _b : 0),
                                    materials: materialsUpdated,
                                });
                                setIsGenerated(true); // Mark as generated since we have existing quote data
                            }
                        }
                        setData(function (prevData) { return (__assign(__assign({}, prevData), { block: res.devis })); });
                    }
                    else {
                        //window.location.href = '/NotFound';
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var addMaterialRow = function () {
        var newRow = {
            id: Date.now().toString(),
            name: '',
            quantity: 1,
            unitPrice: 0,
        };
        setQuoteData(function (prev) { return (__assign(__assign({}, prev), { materials: __spreadArray(__spreadArray([], prev.materials, true), [newRow], false) })); });
    };
    var removeMaterialRow = function (id) {
        setQuoteData(function (prev) { return (__assign(__assign({}, prev), { materials: prev.materials.filter(function (item) { return item.id !== id; }) })); });
    };
    var handleDispatchToMovers = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var response, json, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!moverEmails.trim()) {
                        alert('Please enter at least one moving company email address.');
                        return [2 /*return*/];
                    }
                    setIsDispatching(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(App.api_base + '/dispatch/' + data.slug, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Vuedoo-Domain': App.domain,
                                'X-Vuedoo-Access-Key': '',
                            },
                            body: JSON.stringify({
                                emails: moverEmails.split(/[\s,]+/).filter(function (email) { return email.trim() !== ''; }),
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Dispatch request failed');
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    if (json.status === 'success') {
                        alert('Quote request successfully dispatched to movers!');
                    }
                    else {
                        throw new Error(json.error || 'Dispatch failed');
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    alert('Failed to dispatch. Please try again.');
                    return [3 /*break*/, 6];
                case 5:
                    setIsDispatching(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var formatDate = function (dateString) {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            weekday: 'short', day: 'numeric', month: 'long', year: 'numeric'
        });
    };
    return (_jsxs("div", { className: "container py-3 pb-5", style: { maxWidth: '700px' }, children: [modalImage && (_jsxs("div", { className: "position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-90 d-flex align-items-center justify-content-center z-3", onClick: function () { return setModalImage(null); }, style: { cursor: 'zoom-out' }, children: [_jsx("button", { className: "position-absolute top-0 end-0 btn btn-link text-white p-3 fs-1 fw-bold", onClick: function (e) { e.stopPropagation(); setModalImage(null); }, children: "\u00D7" }), _jsx("img", { src: modalImage, alt: "Zoomed view", className: "img-fluid rounded shadow-lg", style: { maxHeight: '90vh', maxWidth: '95vw', objectFit: 'contain' }, onClick: function (e) { return e.stopPropagation(); } })] })), _jsxs("div", { className: "d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom", children: [_jsxs("div", { children: [_jsx("h4", { className: "fw-bold text-primary mb-1", children: "Request Details" }), _jsx("span", { className: "badge bg-secondary", children: data.block.id })] }), _jsx("span", { className: "badge bg-warning text-dark fs-6 px-3 py-2", children: "Pending Review" })] }), _jsx("div", { className: "card shadow-sm border-0 mb-4", children: _jsxs("div", { className: "card-body", children: [_jsx("h6", { className: "fw-bold text-uppercase text-muted small mb-3", children: "Customer Information" }), _jsxs("div", { className: "row g-3", children: [_jsxs("div", { className: "col-md-6", children: [_jsx("div", { className: "small text-muted", children: "Name" }), _jsx("div", { className: "fw-semibold", children: "Confidential" })] }), _jsxs("div", { className: "col-md-6", children: [_jsx("div", { className: "small text-muted", children: "Contact" }), _jsx("div", { className: "small text-muted", children: data.block.title })] }), _jsxs("div", { className: "col-12", children: [_jsx("div", { className: "small text-muted", children: "Moving Address" }), _jsx("div", { className: "fw-semibold", children: data.block.metas.Address })] }), _jsxs("div", { className: "col-md-6", children: [_jsx("div", { className: "small text-muted", children: "Preferred Date" }), _jsx("div", { className: "fw-semibold", children: formatDate(data.block.metas.MoveDate) })] }), _jsxs("div", { className: "col-md-6", children: [_jsx("div", { className: "small text-muted", children: "Flexibility" }), _jsx("div", { className: "fw-semibold", children: data.block.metas.isFlexible == 'true' ? "Yes (\u00B1 ".concat(data.block.metas.FlexibleDuration.replace('_', ' '), ")") : 'No' })] }), data.block.metas.Notes && (_jsxs("div", { className: "col-12", children: [_jsx("div", { className: "small text-muted", children: "Customer Notes" }), _jsxs("div", { className: "fw-semibold p-2 rounded border", children: ["\"", data.block.metas.Notes, "\""] })] }))] })] }) }), _jsxs("div", { className: "mb-4", children: [_jsx("h6", { className: "fw-bold text-uppercase text-muted small mb-2", children: "Customer Photos (Tap to Zoom)" }), _jsx("div", { className: "d-flex gap-2 overflow-auto pb-2", style: { scrollSnapType: 'x mandatory' }, children: data.block.metas.Photos.map(function (src, idx) { return (_jsx("img", { src: 'https://typewriting-ai-new.s3.us-west-2.amazonaws.com/' + src, alt: "Customer item ".concat(idx + 1), className: "rounded border flex-shrink-0", style: {
                                width: '100px', height: '100px', objectFit: 'cover',
                                scrollSnapAlign: 'start', cursor: 'zoom-in'
                            }, onClick: function () { return setModalImage('https://typewriting-ai-new.s3.us-west-2.amazonaws.com/' + src); } }, idx)); }) })] }), !isGenerated ? (_jsxs("div", { className: "text-center py-4", children: [_jsxs("p", { className: "text-muted mb-3", children: ["Please review the customer details and photos above. ", _jsx("br", {}), "Once verified, generate the material list and estimate to proceed."] }), _jsx("button", { className: "btn btn-primary btn-lg px-5 fw-bold shadow", onClick: handleGenerateList, children: "\u2713 Verify & Generate Material List" })] })) : (
            /* ================= STEP 2: EDITABLE FORM & DISPATCH ================= */
            _jsxs("form", { onSubmit: handleDispatchToMovers, children: [_jsxs("div", { className: "d-flex align-items-center gap-2 mb-3", children: [_jsx("span", { className: "badge bg-success fs-6", children: "Generated" }), _jsx("h5", { className: "fw-bold mb-0", children: "Admin Quote Estimate" })] }), _jsxs("div", { className: "mb-4", children: [_jsx("label", { className: "form-label fw-bold mb-1", children: "Admin Estimated Volume" }), _jsxs("div", { className: "input-group input-group-lg", children: [_jsx("input", { type: "number", step: "0.1", className: "form-control fw-bold text-primary", value: quoteData.totalM3, onChange: function (e) { return handleNumberChange('totalM3', e.target.value); } }), _jsx("span", { className: "input-group-text fw-bold", children: "m\u00B3" })] })] }), _jsxs("div", { className: "mb-4", children: [_jsx("label", { className: "form-label fw-bold mb-2", children: "Packing Materials Estimate" }), _jsx("div", { className: "table-responsive bg-white rounded border", children: _jsxs("table", { className: "table table-borderless mb-0 align-middle", children: [_jsx("thead", { className: "table-light small text-muted", children: _jsxs("tr", { children: [_jsx("th", { style: { width: '45%' }, className: "ps-3", children: "Item" }), _jsx("th", { style: { width: '20%' }, className: "text-center", children: "Qty" }), _jsx("th", { style: { width: '25%' }, className: "text-end", children: "Unit (\u20AC)" }), _jsx("th", { style: { width: '10%' } })] }) }), _jsx("tbody", { children: quoteData.materials.map(function (item) { return (_jsxs("tr", { className: "border-top", children: [_jsx("td", { className: "ps-3", children: _jsx("input", { type: "text", className: "form-control form-control-sm border-0 bg-transparent fw-semibold", value: item.name, onChange: function (e) { return updateMaterial(item.id, 'name', e.target.value); } }) }), _jsx("td", { children: _jsx("input", { type: "number", min: "0", className: "form-control form-control-sm text-center", value: item.quantity, onChange: function (e) { return updateMaterial(item.id, 'quantity', parseInt(e.target.value) || 0); } }) }), _jsx("td", { children: _jsx("input", { type: "number", step: "0.01", min: "0", className: "form-control form-control-sm text-end", value: item.unitPrice, onChange: function (e) { return updateMaterial(item.id, 'unitPrice', parseFloat(e.target.value) || 0); } }) }), _jsx("td", { className: "text-center pe-2", children: _jsx("button", { type: "button", className: "btn btn-sm text-danger p-0", onClick: function () { return removeMaterialRow(item.id); }, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", fill: "currentColor", viewBox: "0 0 16 16", children: _jsx("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" }) }) }) })] }, item.id)); }) })] }) }), _jsx("button", { type: "button", className: "btn btn-outline-primary w-100 mt-2 fw-semibold py-2", onClick: addMaterialRow, children: "+ Add Material Row" })] }), _jsxs("div", { className: "mb-4", children: [_jsx("label", { className: "form-label fw-bold mb-1", children: "Estimated Move Price (Labor, Transport)" }), _jsxs("div", { className: "input-group input-group-lg", children: [_jsx("span", { className: "input-group-text fw-bold bg-light", children: "\u20AC" }), _jsx("input", { type: "number", step: "1", min: "0", className: "form-control fw-bold text-primary", value: quoteData.estimatedMovePrice, onChange: function (e) { return handleNumberChange('estimatedMovePrice', e.target.value); } })] })] }), _jsx("div", { className: "card bg-dark text-white shadow mb-4 border-0", children: _jsxs("div", { className: "card-body", children: [_jsxs("div", { className: "d-flex justify-content-between mb-2 small opacity-75", children: [_jsx("span", { children: "Materials Total:" }), _jsxs("span", { children: ["\u20AC", materialsTotal.toFixed(2)] })] }), _jsxs("div", { className: "d-flex justify-content-between mb-3 small opacity-75", children: [_jsx("span", { children: "Move Price:" }), _jsxs("span", { children: ["\u20AC", quoteData.estimatedMovePrice.toFixed(2)] })] }), _jsx("hr", { className: "border-white opacity-50" }), _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsx("span", { className: "h5 mb-0 fw-bold", children: "Admin Estimate Total" }), _jsxs("span", { className: "h2 mb-0 fw-bold text-warning", children: ["\u20AC", grandTotal.toFixed(2)] })] })] }) }), _jsxs("div", { className: "card shadow-sm border-primary mb-4", children: [_jsx("div", { className: "card-header bg-primary text-white fw-bold", children: "Dispatch to Moving Companies" }), _jsxs("div", { className: "card-body", children: [_jsx("label", { htmlFor: "moverEmails", className: "form-label fw-semibold", children: "Moving Company Emails" }), _jsx("textarea", { id: "moverEmails", className: "form-control mb-2", rows: 4, placeholder: "Enter emails separated by commas or new lines...\ne.g.,\ncontact@mover1.com\ndevis@mover2.fr", value: moverEmails, onChange: function (e) { return setMoverEmails(e.target.value); } }), _jsx("div", { className: "form-text text-muted mb-3", children: "This will send the customer's photos, address, date, and your generated material list to these companies to request their best rates." }), _jsx("div", { className: "d-grid gap-2", children: _jsx("button", { type: "submit", disabled: isDispatching, className: "btn btn-success btn-lg fw-bold py-3 shadow", children: isDispatching ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status", "aria-hidden": "true" }), "Dispatching Requests..."] })) : ('📤 Send Quote Request to Movers') }) })] })] })] }))] }));
}
